import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { apiAction, pageContext } from 'ctm-util-functions';
import { connect } from 'react-redux';
import { quoteFormSelector, validationSelector } from 'ctm-selectors';
import { FormContainer } from './form_container';
import { ThankYou } from './thank_you';
import { apiData } from './data.json';

const nameId = 'shielded.name';
const mobileId = 'shielded.mobile';
const phoneId = 'shielded.phone';
let shieldedRequestSent = false;

class _Container extends PureComponent {

    constructor(props) {
        super(props);
        this.setTouches(props);
    }

    /**
     * Sets base touches when component mounts
     * @param {Object} props - the component props
     */
    setTouches = (props) => {
        const { dispatch } = this.props;
        const ids = [];
        if (props.mobile) {
            ids.push(mobileId);
        } else if (props.phone) {
            ids.push(phoneId);
        }
        if (props.name) {
            ids.push(nameId);
        }
        ids.forEach((id) => {
            dispatch({
                type: 'ELEMENT_TOUCHED',
                identifier: id,
                stateKey: 'vertical.quote'
            });
        });
    };

    /**
     * Handles submitting the form
     */
    handleSubmit = () => {
        const { isValid, dispatch } = this.props;
        if (!isValid) return;
        shieldedRequestSent = true;
        dispatch(apiAction(apiData, pageContext.getProps().pageState));
    };

    render = () => {
        const { dispatch, mobile, phone, name, isValid, isLoading, directOptIn } = this.props;
        return shieldedRequestSent && !directOptIn ? (
            <ThankYou />
        ) : (
            <FormContainer
                valid={isValid}
                loading={directOptIn ? false : isLoading}
                submit={this.handleSubmit}
                dispatch={dispatch}
                name={name}
                mobile={mobile}
                phone={phone}
                nameId={nameId}
                mobileId={mobileId}
                phoneId={phoneId}
                directOptIn={directOptIn}
                shieldedRequestSent={shieldedRequestSent}
            />
        );
    };

    /**
     * Focus the input if required (needed for nested components that are also connected to redux)
     */
    componentDidMount = () => {
        shieldedRequestSent = false;
        const { directOptIn, dispatch } = this.props;
        if (directOptIn) {
            shieldedRequestSent = true;
            dispatch(apiAction(apiData, pageContext.getProps().pageState));
        }
    };

}

_Container.propTypes = {
    dispatch: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
    mobile: PropTypes.string,
    phone: PropTypes.string,
    name: PropTypes.string,
    isLoading: PropTypes.bool,
    directOptIn: PropTypes.bool
};

_Container.defaultProps = {
    isLoading: false
};

const mapStateToProps = (state) => {
    const form = quoteFormSelector(state);
    const name = form.getIn(['shielded', 'name']);
    const mobile = form.getIn(['shielded', 'mobile']);
    const phone = form.getIn(['shielded', 'phone']);
    const validation = validationSelector(state).get('outsideForm');
    const isValid = Boolean(
        validation.get(nameId)
        && (
            validation.get(mobileId)
            || validation.get(phoneId)
        )
    );
    const isLoading = form.getIn(['helpers', 'shielded', 'loading']);
    const postcode = parseInt(form.getIn(['shielded', 'postcode']), 10);
    const directOptIn = !!(
        (
            // all postcodes of Northern Territory
            (postcode >= 800 && postcode < 900)
            // post code of Western Australia that is greater than or equal to 6700
            || (postcode >= 6700 && postcode < 6800)
            // post code of Queensland is greater than or equal to 4740
            || (postcode >= 4740 && postcode < 5000)
        ) && (
            mobile || phone
        )
    );

    return {
        isValid,
        name,
        mobile,
        phone,
        isLoading,
        directOptIn
    };
};

const Container = connect(mapStateToProps)(_Container);

export { _Container, Container };
